import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom' 
import { signin } from '../Actions/userActions';
import LoadingBox from '../Components/LoadingBox'
import MessageBox from '../Components/MessageBox'
import logo from '../Media/logo.png'
import './SignInScreen.css'
import { useToast } from '../Context/ToastContext';

export default function SignInScreen(props) {

    const [emailOrMobile, setEmailOrMobile] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);


    const redirect = props.location.search 
                    ? props.location.search.split('=')[1]
                    : '/';

   const userSignin = useSelector((state) => state.userSignin);
   const { userInfo,loading,error } = userSignin;

    const dispatch = useDispatch();
   const { error: showError } = useToast();

    const submitHandler = (e) => {
        e.preventDefault();
        
        // Enhanced validation
        if (!emailOrMobile.trim()) {
            showError('Please enter your email or mobile number');
            return;
        }
        
        if (!password) {
            showError('Please enter your password');
            return;
        }
        
        // Dispatch signin with email or mobile
        dispatch(signin(emailOrMobile, password));
    }

    useEffect(() =>{
        if(userInfo){
            props.history.push(redirect) ;
            return;
        }

        // Check for pending approval error with one-time ignore to avoid flicker
        if(error === "ACCOUNT_PENDING") {
            const ignoreOnce = (() => { try { return sessionStorage.getItem('ignorePendingOnce') === '1'; } catch(_) { return false; } })();
            if (ignoreOnce) {
                try { sessionStorage.removeItem('ignorePendingOnce'); } catch(_) {}
            } else {
                props.history.push('/pending-approval');
            }
        }
    },[props.history,redirect,userInfo,error]);
    
    return (
        <div className="signin-screen">
            <div className="signin-container">
                <div className="signin-card">
                    <div className="signin-header">
                        <img src={logo} alt="Shopie Bazar Logo" className="logo" />
                        <h1>Welcome Back</h1>
                        <p>Sign in to your Shopie Bazar account</p>
                    </div>

                    <form className="signin-form" onSubmit={submitHandler}>
                        {loading && <LoadingBox />}
                        {error && error !== "ACCOUNT_PENDING" && <MessageBox variant="danger">{error}</MessageBox>}

                        <div className="form-group">
                            <label htmlFor="emailOrMobile">Email or Mobile Number</label>
                            <input 
                                type="text"
                                id="emailOrMobile"
                                placeholder="Enter email or 10-digit mobile number"
                                value={emailOrMobile}
                                onChange={(e) => setEmailOrMobile(e.target.value)}
                                className="form-input"
                                required
                            />
                        </div>

                        <div className="form-group" style={{ position: 'relative' }}>
                            <label htmlFor="password">Password</label>
                            <input 
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-input"
                                required
                                style={{ paddingRight: '44px' }}
                            />
                            <button
                                type="button"
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                onClick={() => setShowPassword(v => !v)}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '35px',
                                    height: '28px',
                                    padding: '0 8px',
                                    border: 'none',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    color: '#555'
                                }}
                            >
                                {showPassword ? (
                                    // Eye off icon
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3l18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                        <path d="M10.58 10.58A3 3 0 0012 15a3 3 0 002.42-4.42M9.9 5.1A10.94 10.94 0 0012 5c5 0 9.27 3.11 11 7.5a11.73 11.73 0 01-4.17 4.88M6.61 6.61A11.73 11.73 0 001 12.5 11.73 11.73 0 006.6 17.39" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                ) : (
                                    // Eye icon
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                                    </svg>
                                )}
                            </button>
                        </div>

                        <div className="form-options">
                            <Link to="/forgot-password" className="forgot-link">
                                Forgot Password?
                            </Link>
                        </div>

                        <button type="submit" className="signin-btn" disabled={loading}>
                            {loading ? 'Signing In...' : 'Sign In'}
                        </button>

                        <div className="signin-footer">
                            <p>
                                New to Shopie Bazar? {' '}
                                <Link to={`/register?redirect=${redirect}`} className="register-link">
                                    Create Account
                                </Link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
